import React, { useEffect, useState } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import TextInput from "../../components/TextInput";
import Dropdown from "../../components/Dropdown";
import HistoryList from "./components/HistoryList";
import DateRangePicker from "../../components/DateRangePicker";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { PERMISSIONS } from '../../constants/index';
import {trimStringFields} from "utils/format";
import {
    getHistoryList,
    setSearchQuery,
    setPageSize,
    setCurrentPage,
} from "../../reducers/companyHistory";
import Copyright from "../../components/Copyright";

const pageSizeOptions = [
    {
        id: 50,
        name: "50件を表示",
    },
    {
        id: 100,
        name: "100件を表示",
    },
    {
        id: 200,
        name: "200件を表示",
    },
];

let startDate = "";
let endDate = "";

const OperationHistory = () => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const currentUser = useSelector((state: any) => state.currentUser);
    const { staffPermission } = currentUser;
    const {
        searchQuery,
        currentPage,
        pageSize,
        sortBy,
        sortOrder,
        historyList,
    } = useSelector((state: any) => state.companyHistory);
    if (!staffPermission[PERMISSIONS.HISTORY_MENU]) {
        return null;
    }

    const pageSizeDefault = pageSizeOptions.find((item: any) => item.id == pageSize);
    const [pageSizeOption, setPageSizeOption] = useState(pageSizeDefault);
    const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

    const fetchHistoryList = (page=currentPage, search=searchQuery) => {
        let data = {
            search: search,
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
        }
        data = trimStringFields(data);
        dispatch(getHistoryList(data));
        dispatch(setCurrentPage(page));
    }

    useEffect(() => {
        fetchHistoryList();
    }, [sortBy, sortOrder, currentPage, pageSize, dateRange]);

    const handleSetSearchQuery = (value: string) => {
        dispatch(setSearchQuery(value));
    };

    const handeSearchHistory = (event: any) => {
        if (event.key === "Enter") {
            fetchHistoryList(1);
        }
    };

    const handleClearSearch = () => {
        handleSetSearchQuery("");
        fetchHistoryList(1, "");
    }

    const handleSetPageSize = (option: any) => {
        dispatch(setCurrentPage(1));
        setPageSizeOption(option);
        dispatch(setPageSize(option.id))
    }

    const handleSetDateRange = (start: any, end: any) => {
        dispatch(setCurrentPage(1));
        setDateRange((prev) => ({
            ...prev,
            startDate: start,
            endDate: end,
        }))
    }

    return (
        <>
        <CompanyHeader />
        <div className="mt-6 px-6 flex gap-6 relative">
            <CompanySideMenu />
            <div className="flex-1">
            <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-8">
                    <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2">
                        操作履歴
                    </h1>
                    <div>
                        <DateRangePicker
                            datePickerQuantity={2}
                            type={1}
                            startDate={startDate}
                            endDate={endDate}
                            onChange={(start: any, end: any) => handleSetDateRange(start, end)}
                        />
                    </div>
                    <div className="w-[10rem]">
                        <Dropdown
                            inputWidth="full"
                            value={pageSizeOption}
                            options={pageSizeOptions}
                            placeholder="選択してください"
                            onChange={(option: any) => handleSetPageSize(option)}
                        />
                    </div>
                </div>

                <TextInput
                    id="search"
                    name="search"
                    value={searchQuery}
                    onChange={(e: any) => handleSetSearchQuery(e.target.value)}
                    placeholder="検索"
                    searchIcon={true}
                    onClearQuery={() => handleClearSearch()}
                    onKeyDown={(e: any) => handeSearchHistory(e)}
                    size="lg"
                />
            </div>
            <div>
                <HistoryList historyList={historyList} />
            </div>
            </div>
        </div>
        <Copyright view="company" />
        </>
    );
};

export default OperationHistory;
